import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from '../styles/UserManager.module.css';

const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filters, setFilters] = useState({
    username: '',
    email: '',
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
      try {
        const token = '98453b6fcbeded7001dfd3eff26f57a7007029bf'; // Token do superuser
        const response = await axios.get('https://crmesquita.com.br/api/usuarios/', {
          headers: {
            Authorization: `Token ${token}`, // Envie o token no cabeçalho
          },
        });
        setUsers(response.data);
        setFilteredUsers(response.data); // Inicialmente, todos os usuários são exibidos
      } catch (error) {
        console.error('Erro ao buscar usuários:', error);
        alert('Erro ao buscar usuários. Verifique sua autenticação.');
      }
    };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const applyFilters = () => {
    let filtered = users;

    // Filtra por nome de usuário
    if (filters.username) {
      filtered = filtered.filter((user) =>
        user.username.toLowerCase().includes(filters.username.toLowerCase())
      );
    }

    // Filtra por email
    if (filters.email) {
      filtered = filtered.filter((user) =>
        user.email.toLowerCase().includes(filters.email.toLowerCase())
      );
    }

    setFilteredUsers(filtered);
  };

  const handleDelete = async (userId) => {
      try {
        const token = '98453b6fcbeded7001dfd3eff26f57a7007029bf'; // Token do superuser
        const userToDelete = users.find((user) => user.id === userId);
    
        if (userToDelete.is_superuser) {
          alert('Não é possível excluir o superusuário!');
          return;
        }
    
        await axios.delete(`https://crmesquita.com.br/api/usuarios/${userId}/`, {
          headers: {
            Authorization: `Token ${token}`, // Envie o token no cabeçalho
          },
        });
    
        setUsers(users.filter((user) => user.id !== userId));
        setFilteredUsers(filteredUsers.filter((user) => user.id !== userId));
        alert('Usuário excluído com sucesso!');
      } catch (error) {
        console.error('Erro ao excluir usuário:', error);
        alert('Erro ao excluir o usuário. Verifique sua autenticação.');
      }
    };

  return (
    <div className={styles['user-manager-container']}>
      <h1 className={styles['user-manager-title']}>Gerenciar Usuários</h1>

      {/* Filtros */}
      <div className={styles['user-manager-filters']}>
        <div className={styles['filter-group']}>
          <label htmlFor="username">Nome de Usuário</label>
          <input
            type="text"
            id="username"
            name="username"
            value={filters.username}
            onChange={handleFilterChange}
            placeholder="Buscar por nome de usuário"
          />
        </div>
        <div className={styles['filter-group']}>
          <label htmlFor="email">Email</label>
          <input
            type="text"
            id="email"
            name="email"
            value={filters.email}
            onChange={handleFilterChange}
            placeholder="Buscar por email"
          />
        </div>
        <button className={styles['apply-filters-button']} onClick={applyFilters}>
          Aplicar Filtros
        </button>
      </div>

      {/* Lista de Usuários */}
      <div className={styles['user-grid']}>
        {filteredUsers.map((user) => (
          <div key={user.id} className={styles['user-card']}>
            <h3 className={styles['user-name']}>{user.username}</h3>
            <p className={styles['user-email']}>Email: {user.email}</p>
            <p className={styles['user-staff']}>
              Tipo: {user.is_staff ? 'Funcionário' : 'Cliente'}
            </p>
            <p className={styles['user-superuser']}>
              Superusuário: {user.is_superuser ? 'Sim' : 'Não'}
            </p>
            <div className={styles['user-actions']}>
              <button
                className={styles['delete-button']}
                onClick={() => handleDelete(user.id)}
              >
                Excluir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserManager;